import { render, staticRenderFns } from "./orderComplete.vue?vue&type=template&id=96978262&scoped=true"
import script from "./orderComplete.vue?vue&type=script&lang=js"
export * from "./orderComplete.vue?vue&type=script&lang=js"
import style0 from "./orderComplete.vue?vue&type=style&index=0&id=96978262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96978262",
  null
  
)

export default component.exports